// Devises officielles Colis2Go — mapping strict demandé par le client.
// La devise est TOUJOURS lue depuis la facture ou l'expédition, jamais déduite de la langue.
export const CURRENCY_SYMBOLS = { GBP: "£", EUR: "€", XOF: "FCFA", GNF: "GNF", USD: "$" };

// Symbole d'une devise (code ISO) — retourne le code brut si inconnu, jamais € par défaut.
export const curSym = (c) => CURRENCY_SYMBOLS[(c || "").toUpperCase()] || (c || "");

// Montant formaté FR + symbole.
export const fmtMoney = (v, c) =>
  (v == null || v === "" ? "—" : `${Number(v).toLocaleString("fr-FR")} ${curSym(c)}`);

// Devise d'une expédition — identique à billing.currency_for côté backend
// (currency posée par la facture > devise des articles > hub d'origine).
export const shipCur = (s) =>
  s?.currency || s?.items_currency ||
  ((s?.origin_country || "").toLowerCase().includes("royaume") ? "GBP" : "EUR");
